import { FunctionComponent, SVGProps } from 'react';

import { SERVICE_IDS } from '@gasbi/shared/common/features/services';

import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';

import AdministrationLogo from '@assets/AdministrationLogo.svg?react';
import CrmLogo from '@assets/CrmLogo.svg?react';
import DistributionLogo from '@assets/DistributionLogo.svg?react';
import HouseholdsLogo from '@assets/HouseholdsIcon.svg?react';

// The services of the Distribution group (Epic GSB-8312); Households carries the logo the app switcher shows for it
// (an icon without a wordmark, so its name is written next to it), the group's own CRM (GSB-8378) Supply Admin's CRM logo.
const SERVICE_LOGOS: Record<
  string,
  FunctionComponent<SVGProps<SVGSVGElement>>
> = {
  [SERVICE_IDS.BMS]: DistributionLogo,
  [SERVICE_IDS.HOUSEHOLDS]: HouseholdsLogo,
  [SERVICE_IDS.DISTRIBUTION_ADMIN]: AdministrationLogo,
  [SERVICE_IDS.DISTRIBUTION_CRM]: CrmLogo,
};

interface ServiceLogoProps {
  serviceId?: string | null;
  /** Height of the logo in px: 16 in a grid row, 24 as the page title (design). */
  height?: number;
}

const ServiceLogo = ({ serviceId, height = 16 }: ServiceLogoProps) => {
  const Logo = serviceId ? SERVICE_LOGOS[serviceId] : undefined;

  if (!Logo) return <>-</>;

  const wordmark = serviceId === SERVICE_IDS.HOUSEHOLDS ? 'households' : null;

  return (
    <Stack
      direction='row'
      alignItems='center'
      sx={{ height: '100%', '& svg': { height, width: 'auto' } }}
    >
      <Logo />
      {wordmark && (
        <Typography
          level={height > 16 ? 'title-lg' : 'title-md'}
          textColor='primary.plainColor'
          sx={{ ml: 0.75 }}
        >
          {wordmark}
        </Typography>
      )}
    </Stack>
  );
};

export default ServiceLogo;
